import { Component, OnInit } from '@angular/core';
import { ManufacturerInterface, ModelInterface, ReportModelInterface, SubtypeInterface } from 'src/app/util/interfaces/manufacturer';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { ManufacturerService } from '../manufacturer/service/manufacturer.service';
import { ModelService } from './service/model.service';
import { ciTypesInterface } from 'src/app/util/interfaces/ciTypes';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { CiFieldService } from 'src/app/page/register-page/register-forms/cmdb/ci-field/service/ci-field.service';
@Component({
	selector: 'register-form-model',
	templateUrl: './model.component.html',
	styleUrls: ['./model.component.scss'],
})
export class ModelComponent implements OnInit {
	icons = {};

	isLoadingLabels = true;
	labels: any = {
		lbl_geral_ativo: 'Active',
		lbl_geral_subtipo: 'Subtype',
		lbl_asset_laptop: 'Notebook',
		lbl_geral_tipo: 'Type',
		lbl_geral_modelo: 'Model',
		lbl_asset_fabricante: 'Manufacturer',
		lbl_geral_procurar_modelos: 'Search for templates',
		lbl_geral_selecione: 'SELECT',
		lbl_geral_location_limpar_campos: 'Reset the fields',
		lbl_geral_novo: 'New',
		lbl_geral_location_ativar: 'Activate',
		lbl_geral_desativar: 'Inactivate',
		lbl_cmdb_nao: 'Not',
		lbl_geral_sim: 'Yes',
		lbl_geral_salvar: 'Save',
		lbl_successful_updated: 'Successful updated',
		lbl_geral_ativado: 'Activated',
		lbl_status_desativado: 'Inactive',
		lbl_geral_versao: 'Version',
		lbl_geral_motivo: 'Reason',
		lbl_geral_cliente: 'Customer',
		lbl_geral_limpar_campos: 'Clear Fields',
		lbl_preencha_todos_asteriscos: 'Fill in at least the fields marked by *',
	};

	model = {} as ModelInterface;
	customInterface: ModelInterface = {
		id: undefined,
		manufacturer: '',
		model: '',
		type: '',
		notebook: '',
		subtype: '',
		active: '',
		name_manufacturer: '',
		label_ct: '',
		label_cs: '',
		release_date: '',
		version: '',
		customer: '',
		message: '',
	};

	setValue: any = '';
	setInputText: any = '';
	selectedType = '';

	selectedTab = 'model';

	// Modelos
	modelsList: ModelInterface[] = [];
	isLoadingModels = true;
	isModelLoading = false;

	// Fabricantes
	manufacturerList: ManufacturerInterface[] = [];
	isLoadingManufacturers = true;

	// Tipos de Ci
	ciTypeList: ciTypesInterface[] = [];
	isLoadingCiTypes = true;

	// Subtipos
	subtypeList: SubtypeInterface[] = [];
	isLoadingSubtypes = true;

	customInterfaceSubtype: SubtypeInterface = {
		ci_type: '',
		label: '',
		id: '',
		name: '',
	};

	showForm = false;
	showAlterForm = false;
	showSubtypeField = false;
	selectedItem = null;
	allSelected = false;

	unbondList = [];

	checkedOptions: { [id: string]: boolean } = {};

	searchText = '';
	searchTextReport = '';
	filteredItems: ModelInterface[] = [];

	//Relatório Modelos
	reportModelList: ReportModelInterface[] = [];
	filteredReport: ReportModelInterface[] = [];
	isReportVisible = false;

	searchHeader: mspTableHeaderI[] = [
		{ name: 'name_manufacturer', value: 'lbl_asset_fabricante', colType: 'text' },
		{ name: 'model', value: 'lbl_geral_modelo', colType: 'text' },
		{ name: 'label_ct', value: 'lbl_asset_tipo_ci', colType: 'text' },
		{ name: 'label_cs', value: 'lbl_geral_subtipo', colType: 'text' },
		// , {"name":"version", "value":"lbl_geral_versao", "colType":""}
		{ name: 'active', value: 'lbl_geral_ativo', colType: 'boolean' },
		{ name: 'icon', value: 'lbl_bulletin_actions', colType: 'icon' },
	];

	constructor(
		private notification: NotificationService,
		private LabelsService: LabelsService,
		private manufacturerService: ManufacturerService,
		private modelService: ModelService,
		private CiFieldService: CiFieldService
	) {}

	ngOnInit() {
		this.setInputText = '';
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});
		this.getAllModels();
		this.getAllManufacturers();
		this.getAllCiType();
		this.getAllSubtype();
		this.filteredItems = this.modelsList;

		if (this.customInterface.type && this.customInterface.type.toString().trim().length > 0) {
			this.getSubtypesByCiType(this.customInterface.type.toString());
		}
	}

	getAllModels() {
		this.modelService.getAllModels().subscribe((models) => {
			this.modelsList = models;
			this.filteredItems = models;
			this.isLoadingModels = false;
		});
	}

	getModel(idModel: string) {
		this.modelService.getModelByID(idModel).subscribe((resp) => {
			this.customInterface = resp;
			this.isModelLoading = false;

			if (this.checkedOptions[idModel]) {
				this.customInterface.isChecked = true;
			}
		});
	}

	getAllManufacturers() {
		this.manufacturerService.getAllManufacturers().subscribe((manufacturers) => {
			this.manufacturerList = manufacturers;
			this.isLoadingManufacturers = false;
		});
	}

	getManufacturer(idManufacturer: string) {
		this.customInterface.manufacturer = idManufacturer;
		this.customInterface.name_manufacturer;
	}

	clearInputs(isNew: boolean) {
		this.customInterface = {
			id: isNew ? '' : undefined,
			manufacturer: '',
			model: '',
			type: '',
			notebook: '',
			subtype: '',
			active: '',
			name_manufacturer: '',
			label_ct: '',
			label_cs: '',
			message: '',
		};

		this.reportModelList = [];
		this.showForm = true;
		this.isReportVisible = false;
	}

	cleanValues() {
		this.customInterface = {
			id: '',
			manufacturer: '',
			active: '',
			version: '',
			customer: '',
			message: '',
			subtype: '',
			type: '',
			model: '',
			notebook: '',
		};

		this.searchText = '';
		this.modelsList = [];
		this.unbondList = [];
		this.filteredItems = [];
		this.showForm = false;
		this.showAlterForm = false;
		this.allSelected = false;
		this.getAllManufacturers();
		this.getAllModels();
		this.searchItems();
		this.getAllSubtype();
		this.getAllCiType();
		this.isLoadingManufacturers = true;
	}

	validateForm() {
		if (this.customInterface.model === '') {
			this.notification.setNotificationMessage(this.labels.lbl_geral_selecione_modelo);
			return false;
		}

		if (this.customInterface.manufacturer === '') {
			this.notification.setNotificationMessage(this.labels.lbl_geral_selecione_fabricante);
			return false;
		}

		if (this.customInterface.type === '') {
			this.notification.setNotificationMessage(this.labels.lbl_geral_selecione_ci);
			return false;
		} else {
			this.saveModel();
		}
	}

	saveModel() {
		if (this.customInterface.id === '') {
			this.modelService.postModel(this.customInterface).subscribe((data) => {
				if (data[0].status == 'Error') {
					this.clearInputs(false);
					return this.notification.setNotificationMessage(this.labels.lbl_geral_possui_modelo);
				} else {
					this.notification.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
					this.isLoadingModels = true;
					this.cleanValues();
					this.clearInputs(false);
					this.getAllModels();
					this.showForm = false;
				}
			});
		}

		if (this.customInterface.id || '') {
			this.modelService.updateModel(this.customInterface).subscribe((data) => {
				if (data[0].status == 'Error') {
					this.clearInputs(false);
					return this.notification.setNotificationMessage(this.labels.lbl_geral_possui_modelo_fabricante);
				}
				this.notification.setNotificationMessage(this.labels.lbl_successful_updated);
				this.isLoadingModels = true;
				this.getModel(this.customInterface.id);
				this.cleanValues();
				this.clearInputs(false);
				this.getAllModels();
			});
		}
	}

	deleteModel(ids, message) {
		const modelIds = Array.isArray(ids) ? ids.map((item) => item.id) : [ids];
		const messageInterface = this.customInterface.message;
		this.modelService.deleteModel(modelIds, messageInterface).subscribe(() => {
			this.notification.setNotificationMessage(this.labels.lbl_status_desativado);
			this.cleanValues();
			this.clearInputs(false);
			this.getAllModels();
		});
	}

	desactiveSelectedModel(event: Event): void {
		let selectedIds: any = '';

		if ((<HTMLElement>event.target).classList.contains('double-click')) {
			const message = this.customInterface.message;
			selectedIds = this.unbondList.length === 0 ? this.customInterface.id : this.unbondList;

			this.deleteModel(selectedIds, message);
			this.unbondList = [];
		} else {
			(<HTMLElement>event.target).classList.add('double-click');

			setTimeout(() => {
				(<HTMLElement>event.target).classList.remove('double-click');
			}, 2000);
		}
	}

	activeModel(ids, message) {
		const modelIds = Array.isArray(ids) ? ids.map((item) => item.id) : [ids];
		const messageInterface = this.customInterface.message;
		this.modelService.activeModel(modelIds, messageInterface).subscribe(() => {
			this.notification.setNotificationMessage(this.labels.lbl_geral_ativado);
			this.cleanValues();
			this.clearInputs(false);
			this.getAllModels();
		});
	}

	activeSelectedModel(event: Event): void {
		let selectedIds: any = '';

		if ((<HTMLElement>event.target).classList.contains('double-click')) {
			const message = this.customInterface.message;
			selectedIds = this.unbondList.length === 0 ? this.customInterface.id : this.unbondList;

			this.activeModel(selectedIds, message);
			this.unbondList = [];
		} else {
			(<HTMLElement>event.target).classList.add('double-click');

			setTimeout(() => {
				(<HTMLElement>event.target).classList.remove('double-click');
			}, 2000);
		}
	}

	selectAll() {
		this.allSelected = !this.allSelected;
		this.unbondList = [];
		this.showAlterForm = false;
		this.customInterface.message = '';

		const items = this.filteredItems.length > 0 ? this.filteredItems : this.modelsList;

		for (const item of items) {
			if (item.version !== 'Manualmente') {
				continue;
			}
			item.isChecked = this.allSelected;
			if (this.allSelected) {
				this.unbondList.push(item);
				this.showAlterForm = true;
			}
		}
	}

	selectMultiple(item, index?): void {
		item.isChecked = !item.isChecked;
		this.checkedOptions[item.id] = item.isChecked;
		this.customInterface.message = '';

		if (item.isChecked) {
			this.unbondList.push(item);
		} else {
			const idIndex = this.unbondList.findIndex((object) => object.id === item.id);
			this.unbondList.splice(idIndex, 1);
		}

		this.showAlterForm = this.unbondList.length === 0 ? false : true;
	}

	searchItems() {
		this.filteredItems = this.modelsList.filter((item) => {
			return (
				(item.name_manufacturer && item.name_manufacturer.toLowerCase().includes(this.searchText.toLowerCase())) ||
				(String(item.model) && String(item.model).toLowerCase().includes(this.searchText.toLowerCase())) ||
				(item.label_ct && item.label_ct.toLowerCase().includes(this.searchText.toLowerCase())) ||
				(item.label_cs && item.label_cs.toLowerCase().includes(this.searchText.toLowerCase())) ||
				(item.version && item.version.toLowerCase().includes(this.searchText.toLowerCase())) ||
				(item.active === 1 && this.labels.lbl_geral_ativo.toLowerCase().includes(this.searchText.toLowerCase())) ||
				(item.active === 0 && this.labels.lbl_geral_desativado.toLowerCase().includes(this.searchText.toLowerCase()))
			);
		});
	}

	searchReport() {
		this.filteredReport = this.reportModelList.filter((item) => {
			return (
				(item.full_name && item.full_name.toLowerCase().includes(this.searchTextReport.toLowerCase())) ||
				(item.date_time && item.date_time.toLowerCase().includes(this.searchTextReport.toLowerCase())) ||
				(item.message && item.message.toLowerCase().includes(this.searchTextReport.toLowerCase()))
			);
		});
	}

	openForm(item: ModelInterface) {
		this.isReportVisible = false;
		this.isReportVisible = true;

		this.selectedItem = item;
		this.customInterface = { ...item } as ModelInterface;
		this.customInterface.message = '';

		if (this.customInterface.type) {
			this.getSubtypesByCiType(this.customInterface.type);
		} else {
			this.showSubtypeField = false;
		}

		this.showForm = true;
	}

	getAllCiType() {
		this.CiFieldService.getAvailableCiTypes().subscribe((ciType) => {
			this.ciTypeList = [];
			this.ciTypeList = ciType;
			this.isLoadingCiTypes = false;
		});
	}

	getAllSubtype() {
		this.modelService.getAllSubtypes().subscribe({
			next: (data) => {
				this.subtypeList = [];
				this.subtypeList = data;
				this.isLoadingSubtypes = false;
			},
			error: () => {
				this.isLoadingSubtypes = false;
			},
		});
	}

	getSubtypesByCiType(id: string) {
		this.modelService.getSubtypesByCiType(id).subscribe((subtype) => {
			if (subtype && subtype.length > 0) {
				this.subtypeList = subtype;
				this.showSubtypeField = true;
				if (this.customInterface.subtype) {
					// Verifica se o valor atual de customInterface.subtype existe na lista de subtipos
					const selectedSubtype = this.subtypeList.find((subtype) => subtype.id === this.customInterface.subtype);
					if (selectedSubtype) {
						if (selectedSubtype.id !== this.customInterface.subtype) {
							// Verifica se o subtipo selecionado é diferente do anterior
							this.customInterface.subtype = selectedSubtype.id; // Atualiza o valor apenas se for diferente do anterior
						}
					} else {
						this.customInterface.subtype = this.subtypeList[0].id; // Define o primeiro subtipo como o valor de customInterface.subtype
					}
				} else {
					this.customInterface.subtype = this.subtypeList[0].id; // Define o primeiro subtipo como o valor de customInterface.subtype
				}
				this.isLoadingSubtypes = false; // Define isLoadingSubtypes apenas após a resposta da API ser recebida
			} else {
				this.showSubtypeField = false;
				this.isLoadingSubtypes = false; // Define isLoadingSubtypes apenas após a resposta da API ser recebida
			}
		});
	}

	getReportModel(id: number) {
		this.modelService.getReportModel(id).subscribe((models) => {
			this.reportModelList = models;
			this.filteredReport = models;
		});
	}
}
